import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {SupportTicketDto} from "../support-ticket.dto";

export class SearchSupportTicketRes extends SearchResultDto {

  public override readonly items: SearchSupportTicketItem[] = [];

  constructor(init?: Partial<SearchSupportTicketRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchSupportTicketItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchSupportTicketItem extends SupportTicketDto implements SearchItem {

  public override readonly id!: string;
  public readonly userNameRaw: string | undefined;

  constructor(init?: Partial<SearchSupportTicketItem>) {
    super(init);
    Object.assign(this, init);
  }
}
